export default {
  apiUrl: new URL('/api/', window.location.href).toString(),
}
